<template>
    <div id="app" :class="[isAr ? 'ar' : 'en']" class="overflow-hidden-x">
        <router-view />
    </div>
</template>

<script>
export default {
    data() {
        return {
            lang: '',
        }
    },
    computed: {
        isAr() {
            this.lang = localStorage.getItem("lang")
            let htmlElement = document.documentElement
            if (this.lang == 'ar') {
                htmlElement.setAttribute('lang', 'ar')
                return true
            }
            else {
                htmlElement.setAttribute('lang', 'en')
                return false
            }
        }
    },
    created() {
        this.lang = localStorage.getItem("lang")
        if (this.lang == null)
            localStorage.setItem("lang", "en")
        this.axios.interceptors.request.use(
            config => {
                config.headers['lang'] = this.lang;
                return config;
            }
        );
    }
};
</script>

<style lang="scss">
.overflow-hidden-x {
    overflow-x: clip;
}
html:lang(ar) * {
    letter-spacing: 0 !important;
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: var(--dark-blue);
}

// h1,
// h2,
// h3,
// h4,
// h5,
// h6 {
//   font-family: "Rubik-Bold", sans-serif !important;
// }

@font-face {
    font-family: "Rubik-Bold";
    src: local("Rubik-Bold"),
        url(./assets/fonts/Rubik-Bold.ttf) format("truetype");
    font-display: swap;
}

.en {
    font-family: "Lato-Regular", sans-serif !important;
    direction: ltr;
}

.ar {
    font-family: "Almarai", sans-serif !important;
    direction: rtl;
}

@font-face {
    font-family: "Almarai";
    src: local("Almarai"),
        url(./assets/fonts/Almarai-Regular.ttf) format("truetype");
}

@font-face {
    font-family: "Lato-Regular";
    src: local("Lato-Regular"),
        url(./assets/fonts/Lato-Regular.ttf) format("truetype");
    font-display: swap;
}

@font-face {
    font-family: "Al-Jazeera-Arabic";
    src: local("Al-Jazeera-Arabic"),
        url(./assets/fonts/Al-Jazeera-Arabic.ttf) format("truetype");
    font-display: swap;
}

a {
    text-decoration: none !important;
}

ul {
    list-style-type: none;
}
</style>
